import React, { useState } from 'react';
import { translate } from '../../../../services/translate';
import { stores } from '../../../../stores';
import SportTreePrematchAdvanced from '../prematch/advanced/SportTreePrematchAdvanced';
import UiButton from '../../../ui/button/UiButton';
import { isFeatureAvailable } from '../../../../services/feature';
import { useStore } from '../../../../hooks/useStore';
import { FEATURE } from '../../../../services/types';
import SportMenuLabelV2 from '../../menu-label-v-2/SportMenuLabelV2';

export default function SportTreeMenu() {
    const [tree] = useStore(stores.sports.prematchTree);
    const [isDisplayingAll, setIsDisplayingAll] = useState(false);
    const [isMenuVisible, setIsMenuVisible] = useState(true);
    const isLayoutB = !isFeatureAvailable(FEATURE.SPORT_LAYOUT_A);
    const INITIAL_VISIBLE_CATEGORY_COUNT = isLayoutB ? 65 : 5;
    const isMainNavigationV2 = isFeatureAvailable(FEATURE.SPORT_MAIN_NAVIGATION_V2);
    const label = translate('Top Sports', 'ui.sportsbook');

    return (
        <>
            {isMainNavigationV2 ? (
                <SportMenuLabelV2 isMenuVisible={isMenuVisible} onDrawerClick={setIsMenuVisible}>
                    {label}
                </SportMenuLabelV2>
            ) : (
                <div className="menu-label">{label}</div>
            )}

            <SportTreePrematchAdvanced
                tree={tree}
                isDisplayingAll={isDisplayingAll}
                initialVisibleCategoryCount={INITIAL_VISIBLE_CATEGORY_COUNT}
                isMenuVisible={isMenuVisible}
            />

            {!isDisplayingAll && isMenuVisible && !isLayoutB && (
                <UiButton block onClick={() => setIsDisplayingAll(true)} className="show-all-sports">
                    {translate('show all', 'ui.sportsbook')}
                </UiButton>
            )}
        </>
    );
}
